import { Controller } from "@hotwired/stimulus";
import { jsonHeader } from '../jssrc/base_ext.js';

export default class extends Controller {
  static targets = ["display", "editor", "input"]
  static values = { url: String, field: String, param: { type: String, default: "skill_type" } }

  edit(event) {
    event.preventDefault();
    this.displayTarget.classList.add('d-none');
    this.editorTarget.classList.remove('d-none');
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  cancel() {
    this.editorTarget.classList.add('d-none');
    this.displayTarget.classList.remove('d-none');
  }

  keydown(event) {
    if (event.key === 'Escape') this.cancel();
    if (event.key === 'Enter') { event.preventDefault(); this.save(); }
  }

  async save() {
    const newValue = this.inputTarget.value.trim();
    if (!newValue) return;

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = {};
    body[this.paramValue] = {};
    body[this.paramValue][this.fieldValue] = newValue;

    this.#setBusy(true);
    try {
      const res = await fetch(this.urlValue, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { ...jsonHeader(), 'X-CSRF-Token': csrf },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (res.ok) {
        this.#updateDisplay(data[this.fieldValue] || newValue);
        this.cancel();
      } else {
        alert(data.errors ? data.errors.join(', ') : 'Update failed');
      }
    } catch (_) {
      alert('Request failed');
    } finally {
      this.#setBusy(false);
    }
  }

  #updateDisplay(value) {
    const link = this.displayTarget.querySelector('a');
    if (link) {
      link.textContent = value;
    } else {
      this.displayTarget.childNodes[0].textContent = value + ' ';
    }
  }

  #setBusy(busy) {
    this.element.querySelectorAll('button').forEach(b => b.disabled = busy);
  }
}
